import api from './api';

// ICD-10 (SA Master Industry Table) — shared by every practice, stored in omniMain.
// search / code are for any signed-in user; the rest are admin.
const icd10Service = {
  search: (q, { limit = 20, all = false } = {}) =>
    api.get('/icd10/search', { params: { q, limit, all: all ? 1 : undefined } }).then((r) => r.data),
  code: (code) => api.get(`/icd10/codes/${encodeURIComponent(code)}`).then((r) => r.data.code),
  status: () => api.get('/icd10/status').then((r) => r.data),
  releases: () => api.get('/icd10/releases').then((r) => r.data.releases || []),
  // The workbook goes up as raw bytes. dryRun returns the preview; nothing is written.
  importFile: (file, { dryRun, allowMassRemoval = false }) =>
    api.post('/icd10/import', file, {
      params: { dryRun: dryRun ? 1 : 0, filename: file.name, allowMassRemoval: allowMassRemoval ? 1 : undefined },
      headers: { 'Content-Type': 'application/octet-stream' },
      timeout: 5 * 60 * 1000,
    }).then((r) => r.data),
  buildEmbeddings: () => api.post('/icd10/embeddings/sync').then((r) => r.data),
};

export default icd10Service;
